export const CREATIVE_VERSIONS_ACTIONS = {
	RESET_CREATIVE_VERSIONS_LIST: "RESET_CREATIVE_VERSIONS_LIST",
	LOAD_CREATIVE_VERSIONS_AJAX: "LOAD_CREATIVE_VERSIONS_AJAX",
	LOAD_CREATIVE_VERSIONS_SUCCESS: "LOAD_CREATIVE_VERSIONS_SUCCESS",
	LOAD_CREATIVE_VERSIONS_ERROR: "LOAD_CREATIVE_VERSIONS_ERROR",
	LOAD_CREATIVE_VERSIONS_CANCEL: "LOAD_CREATIVE_VERSIONS_CANCEL",

	FETCH_SINGLE_CREATIVE_VERSION_AJAX: "FETCH_SINGLE_CREATIVE_VERSION_AJAX",
	FETCH_SINGLE_CREATIVE_VERSION_SUCCESS: "FETCH_SINGLE_CREATIVE_VERSION_SUCCESS",
	FETCH_SINGLE_CREATIVE_VERSION_ERROR: "FETCH_SINGLE_CREATIVE_VERSION_ERROR",

	FETCH_NAMED_CREATIVE_VERSION_AJAX: "FETCH_NAMED_CREATIVE_VERSION_AJAX",
	FETCH_NAMED_CREATIVE_VERSION_SUCCESS: "FETCH_NAMED_CREATIVE_VERSION_SUCCESS",
	FETCH_NAMED_CREATIVE_VERSION_ERROR: "FETCH_NAMED_CREATIVE_VERSION_ERROR",

	LOAD_CREATIVE_VERSIONS_DISTINCTS_AJAX: "LOAD_CREATIVE_VERSIONS_DISTINCTS_AJAX",
	LOAD_CREATIVE_VERSIONS_DISTINCTS_SUCCESS: "LOAD_CREATIVE_VERSIONS_DISTINCTS_SUCCESS",
	LOAD_CREATIVE_VERSIONS_DISTINCTS_ERROR: "LOAD_CREATIVE_VERSIONS_DISTINCTS_ERROR",

	FETCH_ALL_CREATIVE_VERSIONS_AJAX: "FETCH_ALL_CREATIVE_VERSIONS_AJAX",
	FETCH_ALL_CREATIVE_VERSIONS_SUCCESS: "FETCH_ALL_CREATIVE_VERSIONS_SUCCESS",
	FETCH_ALL_CREATIVE_VERSIONS_ERROR: "FETCH_ALL_CREATIVE_VERSIONS_ERROR",

	DELETE_VERSIONS_AJAX:"DELETE_VERSIONS_AJAX",
	DELETE_VERSIONS_SUCCESS:"DELETE_VERSIONS_SUCCESS",
	DELETE_VERSIONS_ERROR:"DELETE_VERSIONS_ERROR",

	CREATE_AUTO_OPTIMIZED_CREATIVE_AJAX: "CREATE_AUTO_OPTIMIZED_CREATIVE_AJAX",
	CREATE_AUTO_OPTIMIZED_CREATIVE_SUCCESS: "CREATE_AUTO_OPTIMIZED_CREATIVE_SUCCESS",
	CREATE_AUTO_OPTIMIZED_CREATIVE_ERROR: "CREATE_AUTO_OPTIMIZED_CREATIVE_ERROR",

	UPDATE_VERSION_VARIABLES_AJAX: "UPDATE_VERSION_VARIABLES_AJAX",
	UPDATE_VERSION_VARIABLES_SUCCESS: "UPDATE_VERSION_VARIABLES_SUCCESS",
	UPDATE_VERSION_VARIABLES_ERROR: "UPDATE_VERSION_VARIABLES_ERROR",

	CREATE_CREATIVE_VERSION_AJAX: "CREATE_CREATIVE_VERSION_AJAX",
	CREATE_CREATIVE_VERSION_SUCCESS: "CREATE_CREATIVE_VERSION_SUCCESS",
	CREATE_CREATIVE_VERSION_ERROR: "CREATE_CREATIVE_VERSION_ERROR",

	UPDATE_VERSION_AJAX: "UPDATE_VERSION_AJAX",
	UPDATE_VERSION_SUCCESS: "UPDATE_VERSION_SUCCESS",
	UPDATE_VERSION_ERROR: "UPDATE_VERSION_ERROR",

	DUPLICATE_CREATIVE_VERSION_AJAX: "DUPLICATE_CREATIVE_VERSION_AJAX",
	DUPLICATE_CREATIVE_VERSION_SUCCESS: "DUPLICATE_CREATIVE_VERSION_SUCCESS",
	DUPLICATE_CREATIVE_VERSION_ERROR: "DUPLICATE_CREATIVE_VERSION_ERROR",

	CREATE_WEIGHTED_ROTATION_CREATIVE_AJAX: "CREATE_WEIGHTED_ROTATION_CREATIVE_AJAX",
	CREATE_WEIGHTED_ROTATION_CREATIVE_SUCCESS: "CREATE_WEIGHTED_ROTATION_CREATIVE_SUCCESS",
	CREATE_WEIGHTED_ROTATION_CREATIVE_ERROR: "CREATE_WEIGHTED_ROTATION_CREATIVE_ERROR",

	PUBLISH_VERSION_AJAX: "PUBLISH_VERSION_AJAX",
	PUBLISH_VERSION_SUCCESS: "PUBLISH_VERSION_SUCCESS",
	PUBLISH_VERSION_ERROR: "PUBLISH_VERSION_ERROR",

	SOCIAL_PUBLISH_VERSION_AJAX: "SOCIAL_PUBLISH_VERSION_AJAX",
	SOCIAL_PUBLISH_VERSION_SUCCESS: "SOCIAL_PUBLISH_VERSION_SUCCESS",
	SOCIAL_PUBLISH_VERSION_ERROR: "SOCIAL_PUBLISH_VERSION_ERROR",

	SOCIAL_UNPUBLISH_VERSION_AJAX: "SOCIAL_UNPUBLISH_VERSION_AJAX",
	SOCIAL_UNPUBLISH_VERSION_SUCCESS: "SOCIAL_UNPUBLISH_VERSION_SUCCESS",
	SOCIAL_UNPUBLISH_VERSION_ERROR: "SOCIAL_UNPUBLISH_VERSION_ERROR",

	IMPORT_DECISION_SHEET_AJAX: "IMPORT_DECISION_SHEET_AJAX",
	IMPORT_DECISION_SHEET_SUCCESS: "IMPORT_DECISION_SHEET_SUCCESS",
	IMPORT_DECISION_SHEET_ERROR: "IMPORT_DECISION_SHEET_ERROR",

	GENERATE_VERSIONS_AJAX:"GENERATE_VERSIONS_AJAX",
	GENERATE_VERSIONS_SUCCESS:"GENERATE_VERSIONS_SUCCESS",
	GENERATE_VERSIONS_ERROR:"GENERATE_VERSIONS_ERROR",

	AI_GENERATE_VERSIONS_RESET:"AI_GENERATE_VERSIONS_RESET",
	AI_GENERATE_VERSIONS_AJAX:"AI_GENERATE_VERSIONS_AJAX",
	AI_GENERATE_VERSIONS_SUCCESS:"AI_GENERATE_VERSIONS_SUCCESS",
	AI_GENERATE_VERSIONS_ERROR:"AI_GENERATE_VERSIONS_ERROR",

	RESET_GENERATION: "RESET_GENERATION",

	FETCH_AUTO_ASSIGN_VARIABLE_ASSETS: "FETCH_AUTO_ASSIGN_VARIABLE_ASSETS",
	FETCH_AUTO_ASSIGN_VARIABLE_ASSETS_SUCCESS: "FETCH_AUTO_ASSIGN_VARIABLE_ASSETS_SUCCESS",
	FETCH_AUTO_ASSIGN_VARIABLE_ASSETS_ERROR: "FETCH_AUTO_ASSIGN_VARIABLE_ASSETS_ERROR",

	FETCH_VERSIONS_WITH_PREFIX: "FETCH_VERSIONS_WITH_PREFIX",
	FETCH_VERSIONS_WITH_PREFIX_SUCCESS: "FETCH_VERSIONS_WITH_PREFIX_SUCCESS",
	FETCH_VERSIONS_WITH_PREFIX_ERROR: "FETCH_VERSIONS_WITH_PREFIX_ERROR",

	FETCH_IMPORT_PREVIEW_VERSIONS: "FETCH_IMPORT_PREVIEW_VERSIONS",
	FETCH_IMPORT_PREVIEW_VERSIONS_SUCCESS: "FETCH_IMPORT_PREVIEW_VERSIONS_SUCCESS",
	FETCH_IMPORT_PREVIEW_VERSIONS_ERROR: "FETCH_IMPORT_PREVIEW_VERSIONS_ERROR",

	FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE: "FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE",
	FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE_SUCCESS: "FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE_SUCCESS",
	FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE_ERROR: "FETCH_IMPORT_PREVIEW_VERSIONS_BY_CREATIVE_ERROR",

	IMPORT_VERSIONS_LABELS_AJAX: "IMPORT_VERSIONS_LABELS_AJAX",
	IMPORT_VERSIONS_LABELS_SUCCESS: "IMPORT_VERSIONS_LABELS_SUCCESS",
	IMPORT_VERSIONS_LABELS_ERROR: "IMPORT_VERSIONS_LABELS_ERROR",

	CLASSIFY_VERSIONS_AJAX: "CLASSIFY_VERSIONS_AJAX",
	CLASSIFY_VERSIONS_SUCCESS: "CLASSIFY_VERSIONS_SUCCESS",
	CLASSIFY_VERSIONS_ERROR: "CLASSIFY_VERSIONS_ERROR",
};
